package ld.scenes;

import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.core.utils.Utils;

import stocking.Scene;
import stocking.AudioManager;
import stocking.SceneManager;

import haxe.ui.Toolkit;
import haxe.ui.components.Button;
import haxe.ui.containers.ListView;
import haxe.ui.core.Component;
import haxe.ui.core.Screen;
import haxe.ui.macros.ComponentMacros;

import ld.scenes.GameScene;


class EditorScene extends Scene
{
	var gameData : ld.Types.LDGameInfoFile;
	var main:Component;

	var lastSelectedEvent : Int = -1;
	var lastSelectedDay : Int = -1;
	
	public function new( renderer : SystemRenderer, stage : Container )
	{
		super( renderer, stage );


	}

	/**
	 *  Days
	 */

	public function onSelectDay( event : haxe.ui.core.UIEvent )
	{
		var list : ListView = cast event.target; 

		if( lastSelectedDay != -1 )
		{
			SaveDay(lastSelectedDay);
			
			SaveToLocalStorage();
			//RebuildLists();
		}

		SelectDay(list.selectedIndex);
		

		lastSelectedDay = list.selectedIndex;
	}

	public function SaveDay( index : Int )
	{
		if( index < 0 )
			return;
			

		var day : ld.Types.LDDay = gameData.days[index];

		#if js
		// @todo This is a horrifying JS-specific hack that shouldn't work in any sane world
		if( day == null )
			day = cast {};
		#end

		// Throw out the old data and rebuild dialogue list
		var groupList:ListView = main.findComponent("day_groups");		
		day.events = new Array<ld.Types.LDDayEvents>();

		for( i in 0 ... groupList.dataSource.size )
		{
			var item = groupList.dataSource.get(i);
			day.events.push({"name": item.name, "group": item.group});
		}

	}

	public function SelectDay( index : Int )
	{

		var dayList:ListView = main.findComponent("day_days");	
		var groupList:ListView = main.findComponent("day_groups");		
		var day : ld.Types.LDDay = dayList.dataSource.get( index );


		while( groupList.dataSource.size > 0 )
			groupList.dataSource.remove( groupList.dataSource.get(0) );

		if( day.events != null )
		{
			for(event in day.events )
			{
				groupList.dataSource.add(event);
			}
		}
	}

	/**
	 *  Events
	 */

	private function SaveEvent( index : Int )
	{
		if( index < 0 )
			return;
			

		var uiName = main.findComponent('evt_name', haxe.ui.components.TextField );
		var uiGroup = main.findComponent('evt_group', haxe.ui.components.TextField );
		var uiSubGroup = main.findComponent('evt_subgroup', haxe.ui.components.TextField );
		var uiImage = main.findComponent('evt_image', haxe.ui.components.TextField );
		var uiUnique = main.findComponent('evt_unique', haxe.ui.components.CheckBox );
		
		var event : ld.Types.LDEvent = gameData.events[index];

		#if js
		// @todo This is a horrifying JS-specific hack that shouldn't work in any sane world
		if( event == null )
			event = cast {};
		#end

		event.name = uiName.text;
		event.group = uiGroup.text;
		event.subgroup = uiSubGroup.text;
		event.unique = uiUnique.value;
		event.image = uiImage.text;

		// Throw out the old data and rebuild dialogue list
		var dialogueList:ListView = main.findComponent("evt_dialogue");		
		event.dialogue = new Array<ld.Types.LDEventDialogue>();

		for( i in 0 ... dialogueList.dataSource.size )
		{
			var item = dialogueList.dataSource.get(i);
			event.dialogue.push({"text": item.text});
		}

		// Throw out the old data and rebuild stats list
		var statsList:ListView = main.findComponent("evt_stats");		
		event.effects = new Array<ld.Types.LDEventEffect>();

		for( i in 0 ... statsList.dataSource.size )
		{
			var item = statsList.dataSource.get(i);
			event.effects.push({"attribute": item.attribute, "change": item.change});
		}

		// Throw out the old data and rebuild stats list
		var statsRequirements:ListView = main.findComponent("evt_requirements");		
		event.requirements = new Array<ld.Types.LDEventRequirements>();

		for( i in 0 ... statsRequirements.dataSource.size )
		{
			var item = statsRequirements.dataSource.get(i);
			event.requirements.push({"attribute": item.attribute, "value": item.value, "operator": item.operator});
		}

		var eventsList:ListView = main.findComponent("events_list");
		eventsList.dataSource.update(index, event);
	}

	private function SelectEvent( index : Int )
	{
		var eventsList:ListView = main.findComponent("events_list");	
		
		var uiName = main.findComponent('evt_name', haxe.ui.components.TextField );
		var uiGroup = main.findComponent('evt_group', haxe.ui.components.TextField );
		var uiSubGroup = main.findComponent('evt_subgroup', haxe.ui.components.TextField );
		var uiUnique = main.findComponent('evt_unique', haxe.ui.components.CheckBox );
		var uiImage = main.findComponent('evt_image', haxe.ui.components.TextField );
		
		var event : ld.Types.LDEvent = eventsList.dataSource.get( eventsList.selectedIndex );

		uiName.value = event.name;
		uiGroup.value = event.group;
		uiSubGroup.value = event.subgroup;
		uiUnique.value = event.unique;
		uiImage.value = event.image;

		var dialogueList:ListView = main.findComponent("evt_dialogue");		
		
		
		while( dialogueList.dataSource.size > 0 )
			dialogueList.dataSource.remove( dialogueList.dataSource.get(0) );

		if( event.dialogue != null )
		{
			for(dialogue in event.dialogue )
			{
				dialogueList.dataSource.add(dialogue);
			}
		}

		// stats
		var statList:ListView = main.findComponent("evt_stats");		

		while( statList.dataSource.size > 0 )
			statList.dataSource.remove( statList.dataSource.get(0) );

		if( event.effects != null )
		{
			for(effect in event.effects )
			{
				statList.dataSource.add(effect);
			}
		}

		// requirements
		var requirementsList:ListView = main.findComponent("evt_requirements");		

		while( requirementsList.dataSource.size > 0 )
			requirementsList.dataSource.remove( requirementsList.dataSource.get(0) );

		if( event.requirements != null )
		{
			for(requirement in event.requirements )
			{
				requirementsList.dataSource.add(requirement);
			}
		}

	}

	public function onSelectEvent( event : haxe.ui.core.UIEvent )
	{
		var list : ListView = cast event.target; 


		if( lastSelectedEvent != -1 )
		{
			SaveEvent(lastSelectedEvent);
			
			SaveToLocalStorage();
			//RebuildLists();
		}

		SelectEvent(list.selectedIndex);
		

		lastSelectedEvent = list.selectedIndex;

	}

		/**
	 *  stat loc
	 */

	private function SaveStatLoc( index : Int )
	{
		if( index < 0 )
			return;

		trace("save stat id" + index);

		var uiID = main.findComponent('statloc_id', haxe.ui.components.TextField );
		var uiName = main.findComponent('statloc_name', haxe.ui.components.TextField );
		var uiPositive = main.findComponent('statloc_positive', haxe.ui.components.CheckBox );
		
		var event : ld.Types.LDLocalizedStat;

		if( gameData.localizedStats != null && gameData.localizedStats[index] != null)
			event = gameData.localizedStats[index];
		else
			event = cast {};
		

		event.name = uiName.text;
		event.id = uiID.text;
		event.positive = uiPositive.value;
		trace("checkbox value:",uiPositive.value);

	}

	private function SelectStatLoc( index : Int )
	{
		var eventsList:ListView = main.findComponent("statloc_list");	
		
		var uiName = main.findComponent('statloc_name', haxe.ui.components.TextField );
		var uiID = main.findComponent('statloc_id', haxe.ui.components.TextField );
		var uiPositive = main.findComponent('statloc_positive', haxe.ui.components.CheckBox );
		
		
		var event : ld.Types.LDLocalizedStat = eventsList.dataSource.get( eventsList.selectedIndex );

		uiName.value = event.name;
		uiID.value = event.id;
		uiPositive.value = event.positive;
	

	}

	public function onSelectStatLoc( event : haxe.ui.core.UIEvent )
	{
		var list : ListView = cast event.target; 


		if( lastSelectedEvent != -1 )
		{
			SaveStatLoc(lastSelectedEvent);
			
			SaveToLocalStorage();
			//RebuildLists();
		}

		SelectStatLoc(list.selectedIndex);
		
		lastSelectedEvent = list.selectedIndex;

	}

	public function SaveToLocalStorage()
	{
		trace("write to LS");
		SyncToLocalData();

		var storage = js.Browser.getLocalStorage();

		if( storage != null )
			storage.setItem("local_gamedata", haxe.Json.stringify( gameData ) );
	}

	public function SyncToLocalData()
	{
		var eventlist:ListView = main.findComponent("events_list", null, true);
		var statlocList:ListView = main.findComponent("statloc_list", null, true);
		var dayList:ListView = main.findComponent("day_days", null, true);

		gameData.events = new Array<ld.Types.LDEvent>();
		for( i in 0... eventlist.dataSource.size )
		{
			gameData.events.push( cast eventlist.dataSource.get(i) );
		}

		gameData.localizedStats = new Array<ld.Types.LDLocalizedStat>();
		for( i in 0... statlocList.dataSource.size )
		{
			gameData.localizedStats.push( cast statlocList.dataSource.get(i) );
		}

		gameData.days = new Array<ld.Types.LDDay>();
		for( i in 0... dayList.dataSource.size )
		{
			gameData.days.push( cast dayList.dataSource.get(i) );
		}
	}

	public function RebuildLists()
	{
		var eventlist:ListView = main.findComponent("events_list", null, true);

		while( eventlist.dataSource.size > 0 )
			eventlist.dataSource.remove( eventlist.dataSource.get(0) );

		for( event in gameData.events )
		{
			eventlist.dataSource.add(event);
		}

		var dayList:ListView = main.findComponent("day_days", null, true);

		while( dayList.dataSource.size > 0 )
			dayList.dataSource.remove( dayList.dataSource.get(0) );

		for( day in gameData.days )
		{
			dayList.dataSource.add(day);
		}

		var statList:ListView = main.findComponent("statloc_list", null, true);

		while( statList.dataSource.size > 0 )
			statList.dataSource.remove( statList.dataSource.get(0) );

		if( gameData.localizedStats!= null )
		{
			for( row in gameData.localizedStats )
			{
				statList.dataSource.add(row);
			}
		}
	}


    public override function preload()
    {
		loaderData = [
			// 1993 Mazda NOT AN IMAGE
			{ filename: "assets/gamedata.json", alias: "gamedata"},
		];
		super.preload();
    }


	public override function enter()
	{
		super.enter();

		
		Toolkit.init({
			stage: stage,      // the default place 'Screen' will place objects
			renderer: renderer // the renderer that is being used
		});

		main = ComponentMacros.buildComponent("assets/ui/editor.xml");

        /*
         * We are using 'Screen.instance.addComponent' as its more cross framework,
         * however, would could have also used '_stage.addChild'
         */
        Screen.instance.addComponent(main);

		if( !dataCache.exists('gamedata') )
		{
			throw("tried to enter before gamedata loaded. How??");
		}

		gameData = dataCache.get('gamedata');

		var storage = js.Browser.getLocalStorage();
		if( storage != null )
		{
			var storedJSON = storage.getItem("local_gamedata" );

			if( storedJSON != null )
			{
				gameData = haxe.Json.parse( storedJSON );
				trace("Loaded from LS");
			}
		}

        var eventlist:ListView = main.findComponent("events_list");
		eventlist.onChange = onSelectEvent;

		var daylist:ListView = main.findComponent("day_days");
		daylist.onChange = onSelectDay;

		var statlocList:ListView = main.findComponent("statloc_list");
		statlocList.onChange = onSelectStatLoc;

		/*var btnGame:Button = main.findComponent("btn_file_game");
		btnGame.onClick = function( event : haxe.ui.core.MouseEvent ){
				SceneManager.instance.transitionToScene( new GameScene( renderer, stage ) );
				main.removeAllComponents();
		};*/


		var btnGame:Button = main.findComponent("btn_file_save");
		btnGame.onClick = function( event : haxe.ui.core.MouseEvent ){
				var list : ListView = cast main.findComponent("day_days");
				SaveDay(list.selectedIndex);

				var list : ListView = cast main.findComponent("events_list");
				SaveEvent(list.selectedIndex);

				var list : ListView = cast main.findComponent("statloc_list");
				SaveStatLoc(list.selectedIndex);

				SaveToLocalStorage();

				lib.FileSave.saveClickJson( gameData, "gamedata.json" );
		};

		var btnGame:Button = main.findComponent("btn_file_load");
		btnGame.onClick = function( event : haxe.ui.core.MouseEvent ){
				var textarea : haxe.ui.components.TextArea = cast main.findComponent("load_text");
				
				gameData = haxe.Json.parse( textarea.text );
				trace("Loaded from file");
				var storage = js.Browser.getLocalStorage();

				if( storage != null )
					storage.setItem("local_gamedata", haxe.Json.stringify( gameData ) );

				RebuildLists();
		};

		
		var btnGame:Button = main.findComponent("btn_evt_duplicate");
		btnGame.onClick = function( event : haxe.ui.core.MouseEvent ){

			var item : ld.Types.LDEvent = cast eventlist.dataSource.get( eventlist.selectedIndex );
			item = Reflect.copy( item );

			eventlist.dataSource.add( item );
		};

		RebuildLists();

	}


	public override function tick( delta : Float )
	{

	}
}
